import { render, staticRenderFns } from "./InboxWindowMessagesNew.vue?vue&type=template&id=325cc717&scoped=true"
import script from "./InboxWindowMessagesNew.vue?vue&type=script&lang=ts"
export * from "./InboxWindowMessagesNew.vue?vue&type=script&lang=ts"
import style0 from "./InboxWindowMessagesNew.vue?vue&type=style&index=0&id=325cc717&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325cc717",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('325cc717')) {
      api.createRecord('325cc717', component.options)
    } else {
      api.reload('325cc717', component.options)
    }
    module.hot.accept("./InboxWindowMessagesNew.vue?vue&type=template&id=325cc717&scoped=true", function () {
      api.rerender('325cc717', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inbox/InboxWindowMessagesNew.vue"
export default component.exports